import React, { useEffect } from 'react';
import moment from 'moment';
import { View, Text, IconButton, Divider, Weekdays, Month, useCalendarContext, Icon, useStyleSheet, createStyleSheet, useThemeContext } from '@gopeerproject/ui-kit';
import { useCalendarDropdownContext } from '../contexts';
import { DateInput } from './DateInput';
export const RangeCalendar = ({ displayLabels, rangeContainerStyle, hideWeekdaysDivider }) => {
    const { size } = useThemeContext();
    const styles = useStyleSheet(getStyles);
    const { from, to, setFrom, setTo, setRange } = useCalendarDropdownContext();
    const { active, setActive, prev, next } = useCalendarContext();
    useEffect(() => {
        if (from)
            setActive(from);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: styles.inputs },
            React.createElement(DateInput, { date: from, setDate: setFrom, label: displayLabels ? 'Start date' : undefined }),
            React.createElement(View, { style: styles.iconContainer },
                React.createElement(Icon, { name: 'arrow-right', size: size.J })),
            React.createElement(DateInput, { date: to, setDate: setTo, label: displayLabels ? 'End date' : undefined })),
        React.createElement(View, { style: [styles.calendarContainer, rangeContainerStyle] },
            React.createElement(View, { style: styles.nav },
                React.createElement(Text, { type: 'heading', size: 'h6', style: styles.title }, moment(active).format('MMMM YYYY')),
                React.createElement(IconButton, { size: 'xs', type: 'tertiary', accent: 'neutral', onPress: prev, value: 'chevron-left' }),
                React.createElement(IconButton, { size: 'xs', type: 'tertiary', accent: 'neutral', onPress: next, value: 'chevron-right' })),
            React.createElement(Weekdays, null),
            hideWeekdaysDivider ? null : React.createElement(Divider, { type: 'horizontal' }),
            React.createElement(View, null,
                React.createElement(Month, { size: 'lg', date: moment(active).startOf('month').toISOString(), onSelect: (date) => {
                        // if clicked on start or end dates clear them and start from the new date
                        if (from && moment(date).isSame(from, 'day'))
                            setRange({ from: undefined, to: undefined });
                        else if (to && moment(date).isSame(to, 'day'))
                            setRange({ from: date, to: undefined });
                        else if (from && to) {
                            // default behaviour
                            if (moment(date).isBefore(from, 'day'))
                                setFrom(date);
                            else
                                setTo(date);
                        }
                        else if (from) {
                            // if only start date is selected
                            if (moment(date).isAfter(from, 'day'))
                                setTo(date);
                            else
                                setRange({ from: date, to: from });
                        }
                        else if (to) {
                            // if only end date is selected
                            if (moment(date).isBefore(to, 'day'))
                                setFrom(date);
                            else
                                setRange({ from: to, to: date });
                        }
                        else
                            setFrom(date);
                    }, selected: [from, to].filter(Boolean), highlighted: from && to
                        ? Array.from(Array(Math.abs(moment(to).diff(from, 'days')) + 1)).map((_, i) => moment(from).add(i, 'day').toISOString())
                        : [] })))));
};
const getStyles = createStyleSheet(({ size }) => ({
    inputs: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: size.G
    },
    calendarContainer: { padding: size.E, gap: size.B },
    nav: { flexDirection: 'row', alignItems: 'center', gap: size.B },
    title: { marginRight: 'auto' },
    iconContainer: {
        marginBottom: (55 - size.J) / 2 // 55 is the height of the  container
    }
}));
//# sourceMappingURL=RangeCalendar.js.map